export default __webpack_public_path__ + "media/images/features/saga/rice_fields-10a29cc6ad3750710edd75d8648ed4eb.jpg";